/**
 * ช่วงวันของ "งวดเงินเดือน" ตามรอบตัดวีคของบริษัท (26–25 — ยืนยันกับ HR มั่งมีทรัพย์).
 * งวด YYYY-MM = วันที่ 26 ของเดือนก่อนหน้า → 25 ของเดือนงวด.
 * เช่น 2026-09 → { start: '2026-08-26', end: '2026-09-25' }.
 * รอบค่าคอม (จ่ายนอกรอบ) ใช้ช่วงเดียวกันนี้: งวด = เดือนที่คิดเงิน ไม่ใช่เดือนที่โอน
 * เช่น งวด 2026-09 โอน 15 ต.ค. ก็คิดจาก 26 ส.ค.–25 ก.ย.
 * ใช้เป็น "ที่เดียวจริง ๆ" ของช่วงวันงวด — ทุก handler (reconcile/run/docking/preview/payout)
 * และหน้าจอที่เลือกรอบ ต้องเรียกตัวนี้ ห้ามคิด period-01..สิ้นเดือน เองอีก (ไม่งั้นคนละช่วงกัน = เลขเพี้ยน).
 * ⚠️ tenants.cutoff_day ไม่ได้กำหนดช่วงนี้ (ค่านั้นใช้กับการลาย้อนหลัง/แจ้งเตือน) อย่าเอามาคิดรอบแยกเอง.
 */
export function cycleRange(period: string): { start: string; end: string } {
  const [y, m] = period.split('-').map(Number);
  if (!y || !m) throw new Error('Invalid period: ' + period);
  const start = new Date(Date.UTC(y, m - 2, 26)).toISOString().slice(0, 10); // 26 ของเดือน (M-1)
  const end = new Date(Date.UTC(y, m - 1, 25)).toISOString().slice(0, 10);   // 25 ของเดือน (M)
  return { start, end };
}

/**
 * งวดเงินเดือนของวันที่หนึ่ง — ผกผันของ cycleRange (26 เป็นต้นไปอยู่งวดของเดือนถัดไป).
 * เช่น 2026-10-25 → 2026-10 · 2026-10-26 → 2026-11 · 2026-12-31 → 2027-01.
 * ⚠️ ห้ามใช้ date.slice(0, 7) แทนงวด — วันที่ 26–สิ้นเดือนจะไปตกงวดก่อนหน้า 1 งวด.
 */
export function cyclePeriodOf(date: string): string {
  const y = Number(date.slice(0, 4));
  const m = Number(date.slice(5, 7));
  const d = Number(date.slice(8, 10));
  if (!y || !m || !d) throw new Error('Invalid date: ' + date);
  return new Date(Date.UTC(y, d >= 26 ? m : m - 1, 1)).toISOString().slice(0, 7);
}
